// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.fi-countries-select .mat-form-field-small {
  margin-right: 10px;
}
.fi-countries-select .mat-form-field-small .mat-form-field-infix {
  padding-top: 8px;
}
.fi-countries-select .mat-form-field-small .mat-form-field-infix .mat-select-arrow-wrapper {
  transform: none;
}
.fi-countries-select .mat-form-field-small .mat-select-trigger {
  vertical-align: bottom;
}
.fi-countries-select .mat-form-field-small .mat-select-trigger .country-flag,
.fi-countries-select .mat-form-field-small .mat-select-trigger .country-code {
  display: inline-block;
  vertical-align: middle;
}
.fi-countries-select .mat-form-field-small .mat-select-trigger .country-flag {
  width: 23px;
  height: 23px;
  margin-right: 5px;
}
.fi-countries-select .mat-form-field-small .mat-form-field-flex {
  height: 55px;
}
.fi-countries-select .mat-form-field-small.mat-mdc-form-field-type-mat-select.mat-form-field-appearance-outline .mdc-notched-outline__notch {
  max-width: 100%;
}

.mat-mdc-select-panel .mat-mdc-option .mdc-list-item__primary-text span {
  letter-spacing: normal;
  font-size: 14px;
}`, "",{"version":3,"sources":["webpack://./Source/app/shared/fi-contacts/fi-countries-select/fi-countries-select.component.scss"],"names":[],"mappings":"AACI;EACI,kBAAA;AAAR;AACQ;EACI,gBAAA;AACZ;AAAY;EACI,eAAA;AAEhB;AACQ;EACI,sBAAA;AACZ;AAAY;;EAEI,qBAAA;EACA,sBAAA;AAEhB;AACY;EACI,WAAA;EACA,YAAA;EACA,iBAAA;AAChB;AAEQ;EACI,YAAA;AAAZ;AAGQ;EACI,eAAA;AADZ;;AAMA;EACI,sBAAA;EACA,eAAA;AAHJ","sourcesContent":[".fi-countries-select {\r\n    .mat-form-field-small {\r\n        margin-right: 10px;\r\n        .mat-form-field-infix {\r\n            padding-top: 8px;\r\n            .mat-select-arrow-wrapper {\r\n                transform: none;\r\n            }\r\n        }\r\n        .mat-select-trigger {\r\n            vertical-align: bottom;\r\n            .country-flag,\r\n            .country-code {\r\n                display: inline-block;\r\n                vertical-align: middle;\r\n            }\r\n\r\n            .country-flag {\r\n                width: 23px;\r\n                height: 23px;\r\n                margin-right: 5px;\r\n            }\r\n        }\r\n        .mat-form-field-flex {\r\n            height: 55px;\r\n        }\r\n\r\n        &.mat-mdc-form-field-type-mat-select.mat-form-field-appearance-outline .mdc-notched-outline__notch {\r\n            max-width: 100%;\r\n        }\r\n    }\r\n}\r\n\r\n.mat-mdc-select-panel .mat-mdc-option .mdc-list-item__primary-text span {\r\n    letter-spacing: normal;\r\n    font-size: 14px;\r\n}\r\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
